import { LoadingStatusEnum } from '../../../constants/enums';

const initialState = {
  factoryFileList: [],
  loading: LoadingStatusEnum.Idle,
};

export default initialState;
